<template>
  <div class="bun-container">
    <LoaderImg v-if="loading"></LoaderImg>
    <img :src="errorImage" v-else-if="error">
    <div class="bun__aligner" v-else>
      <div class="bun-base bun-image">
        <img :src="bunImage"/>
      </div>
      <div class="bun-layer-seeding bun-image" v-if="curRecipe.seeding.key !== undefined">
        <img :src="seedingImage"/>
      </div>
      <div class="bun-layer-surface bun-image" v-if="curRecipe.surface.key !== undefined">
        <img :src="surfaceImage"/>
      </div>
      <div class="bun-label" v-if="curRecipe.label.id !== undefined">
        <img :src="labelImage"/>
      </div>
      <emoji-canvas />
    </div>
  </div>
</template>

<script>
import ImageLoader from "./ImageLoader";
import LoaderImg from "./LoaderImg";
import EmojiCanvas from "./Emoji/EmojiCanvas";

export default {
  name: "Bun",
  components: {EmojiCanvas, LoaderImg, ImageLoader},
  data: function () {
    return {
      thumbnail: 'full',
      loadingStack: ['bunImage'],
      errorStack: [],
    }
  },
  computed: {
    errorImage: function () {
      return this.host + this.$store.state.errorImage;
    },

    loading: function () {
      return (this.loadingStack.length > 0)
    },

    error: function () {
      return (this.errorStack.length > 0)
    },

    host: function () {
      return this.$store.getters.host();
    },

    curRecipe: function () {
      return this.$store.state.curRecipe;
    },

    baseImage: function () {
      return this.host + '/images/buns/' + this.thumbnail + '__' + this.curRecipe.bun.key + '_' + this.curRecipe.size.key + '_';
    },

    bunImage: function () {
      return this.baseImage + this.curRecipe.colour.key + '_' + this.curRecipe.dough.key;
    },

    seedingImage: function () {
      return this.baseImage + this.curRecipe.seeding.key;
    },

    surfaceImage: function () {
      return this.baseImage + this.curRecipe.surface.key;
    },

    labelImage: function () {
      return this.host + this.curRecipe.label.logo
    }
  },
  mounted() {
    // show bun if it was already preloaded
    if (this.curRecipe.bun.key !== undefined)
      this.load('bunImage');

    // show seeding if it was already preloaded
    if (this.curRecipe.seeding.key !== undefined)
      this.load('seedingImage');

    // show seeding if it was already preloaded
    if (this.curRecipe.surface.key !== undefined)
      this.load('surfaceImage');

    if (this.curRecipe.label.id !== undefined)
      this.load('labelImage');
  },
  methods: {
    load(imageType) {
      this.addToLoadingStack(imageType);

      let src = this[imageType];

      // prepare image source
      let image = new Image();
      image.src = src;

      // when successfully loaded
      image.onload = function () {
        this.removeFromErrorStack(imageType);
        this.removeFromLoadingStack(imageType);
      }.bind(this);

      // when loading failed
      image.onerror = function () {
        this.addToErrorStack(imageType);
        this.removeFromLoadingStack(imageType);
      }.bind(this);
    },

    /**
     * add image to loading stack
     * @param name
     */
    addToLoadingStack(name) {
      if (this.loadingStack.indexOf(name) == -1)
        this.loadingStack.push(name);
    },

    /**
     * remove image from loading stack
     * @param name
     */
    removeFromLoadingStack(name) {
      this.loadingStack.splice(this.loadingStack.indexOf(name), 1);
    },

    /**
     * add image to error stack
     * @param name
     */
    addToErrorStack(name) {
      if (this.errorStack.indexOf(name) == -1)
        this.errorStack.push(name);
    },

    /**
     * remove image to error stack
     * @param name
     */
    removeFromErrorStack(name) {
      this.errorStack.splice(this.errorStack.indexOf(name), 1);
    }
  },
  watch: {
    'bunImage': function () {
      this.load('bunImage');
    },
    'seedingImage': function () {
      if (this.curRecipe.seeding.key !== undefined)
        this.load('seedingImage');
    },
    'surfaceImage': function () {
      if (this.curRecipe.surface.key !== undefined)
        this.load('surfaceImage');
    },
    'labelImage': function () {
      if (this.curRecipe.label.logo !== undefined)
        this.load('labelImage');
    }
  }
}
</script>
